import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {translationItemByMessageIdSelector, handleCrudTranslation, setTranslationByMessageId, deleteTranslationByMessageId, translationsMessageIdsSelector} from "../../modules/app"
import { reduxForm, Field } from 'redux-form'
import RenderInputFormGroup from '../common/Form/RenderInputFormGroup'
import {required} from "../common/Form/rules"
import {uniqueTranslationFromExist} from './rules'
import {push} from 'react-router-redux'
import {routesUrls} from "../../settings/routes"


class TranslationItem extends Component {
    render() {
        let {handleSubmit, error, submitting, submitSucceeded, translationItemByMessageId : {messageId} = {}} = this.props
        let {formatMessage} = this.context

        return (
            <form className="profile-form" onSubmit={handleSubmit}>
                <div className="row">
                    {
                        this.isNewTranslation() && (
                            <Field
                                name = "message-id"
                                type = "text"
                                component = {RenderInputFormGroup}
                                label = {`${formatMessage("Message id")}:`}
                                id = "message-id"
                                validate = {[required, uniqueTranslationFromExist]}
                                autoComplete = "off"
                            />
                        )
                    }
                    {
                        !this.isNewTranslation() && (
                            <div className="form-group">
                                <label className="control-label">{formatMessage("Message id")}:</label>
                                <p>{messageId}</p>
                            </div>
                        )
                    }
                </div>
                <div className="row">
                    <Field
                        name = "en"
                        type = "text"
                        component = {RenderInputFormGroup}
                        label = {`${formatMessage("en")}:`}
                        id = "en"
                        autoComplete = "off"
                    />
                </div>
                <div className="row">
                    <Field
                        name = "de"
                        type = "text"
                        component = {RenderInputFormGroup}
                        label = {`${formatMessage("de")}:`}
                        id = "de"
                        autoComplete = "off"
                    />
                </div>

                {
                    submitSucceeded &&
                    <div className="row">
                        <div className="col-xs-12 text-center text-success">{formatMessage("Translation updated")}.</div>
                    </div>
                }

                {
                    error &&
                    <div className="row">
                        <div className="col-xs-12 text-center text-danger">{error}</div>
                    </div>
                }

                <div className="btn-fld">
                    {
                        !this.isNewTranslation() && (
                            <button
                                className="btn btn-danger btn-sm"
                                type="button"
                                disabled={submitting}
                                onClick={handleSubmit((values, ...args) => {
                                    return this.props.onSubmit({
                                        ...values,
                                        deleting: true
                                    }, ...args)
                                })}
                            >{formatMessage("Delete")}</button>
                        )
                    }
                    <button
                        className="btn btn-primary btn-sm"
                        type="submit"
                        disabled={submitting}
                    >{formatMessage("Save")}</button>
                </div>
            </form>
        )
    }

    isNewTranslation = () => !this.props.translationItemByMessageId

    static contextTypes = {formatMessage: PropTypes.any}
}


export default connect(
    (state, ownProps) => {
        let translationItemByMessageId = translationItemByMessageIdSelector(state, ownProps.id)
        let {messageId = "", en = "", de = ""} = translationItemByMessageId || {}
        return {
            translationItemByMessageId,
            translationsMessageIds : translationsMessageIdsSelector(state),
            initialValues : {
                "message-id" : messageId,
                en,
                de,
            },
        }
    }
)(reduxForm({
    form: 'translation-item',
    onSubmit : (values, dispatch) => {
        let {deleting, en, de, 'message-id' : messageId, translationsMessageIds} = values

        return handleCrudTranslation({
            messageId,
            en,
            de,
            deleting,
            translationsMessageIds
        })
            .then(() => {
                if (deleting) {
                    dispatch(push(routesUrls.adminTranslations))
                    dispatch(deleteTranslationByMessageId({
                        messageId
                    }))
                } else {
                    dispatch(push(routesUrls.adminTranslations))
                    dispatch(setTranslationByMessageId({
                        messageId,
                        en,
                        de,
                    }))
                }
            })
    }
})(TranslationItem))


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/AdminPanel/TranslationItem.js